// Selection slice — which keypoint is selected in each view, and which view
// is "active" (border highlight). Spec §4.2, §6.3.1.

import type { StateCreator } from 'zustand';
import type { KeypointName } from '../types';
import type { AppState } from './index';
import type { Side } from './predictions';

export interface SelectionSlice {
  activeView: Side | null;
  selectedFrontLeft: KeypointName | null;
  selectedFrontRight: KeypointName | null;
  selectedLeft: KeypointName | null;
  selectedRight: KeypointName | null;
  selectKeypoint: (side: Side, name: KeypointName | null) => void;
  setActiveView: (view: Side | null) => void;
}

export const createSelectionSlice: StateCreator<
  AppState,
  [['zustand/immer', never]],
  [],
  SelectionSlice
> = (set) => ({
  activeView: null,
  selectedFrontLeft: null,
  selectedFrontRight: null,
  selectedLeft: null,
  selectedRight: null,
  selectKeypoint: (side, name) =>
    set((s) => {
      if (side === 'front_left') s.selectedFrontLeft = name;
      else if (side === 'front_right') s.selectedFrontRight = name;
      else if (side === 'left') s.selectedLeft = name;
      else s.selectedRight = name;
    }),
  setActiveView: (view) =>
    set((s) => {
      s.activeView = view;
    }),
});
